import { Box, Flex, Text } from 'theme-ui';
import CloseV2 from '~/assets/images/icons/closeV2.svg';

type specialProps = {
  isSpecialNoteOpen: boolean;
  setIsSpecialNoteOpen: React.Dispatch<React.SetStateAction<boolean>>;
  specialNoteMobile: {
    childMarkdownRemark: { readonly html: string | null };
  } | null;
  specialNoteDesktop: {
    childMarkdownRemark: { readonly html: string | null };
  } | null;
};

const SpecialNote = ({ isSpecialNoteOpen, setIsSpecialNoteOpen, specialNoteDesktop, specialNoteMobile }: specialProps) => (
  <Box
    sx={{
      py: ['2sm', '3xs'],
      px: ['2rem', '3xs'],
      backgroundColor: '#D8EADD',
      border: '1px solid #2D9152',
      position: 'relative',
      display: isSpecialNoteOpen ? 'block' : 'none',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: ['0.6rem', '0'],
        right: '1.1rem',
        zIndex: 1,
        '& svg': { width: '10px', height: '10px', '& path': { stroke: '#2D9152' } },
        cursor: 'pointer',
      }}
      onClick={() => {
        setIsSpecialNoteOpen(false);
      }}
      role="button"
    >
      <CloseV2 />
    </Box>
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        p: ['1rem 0', '0.5rem, 1.5rem'],
        fontSize: ['1.4rem', '1.6rem'],
        textAlign: 'center',
        color: '#2D9152',
        '& p': { m: '0' },
      }}
    >
      {specialNoteMobile && (
        <Text
          variant="buttonLight"
          sx={{ display: ['block', 'none'] }}
          dangerouslySetInnerHTML={{
            __html: specialNoteMobile?.childMarkdownRemark?.html || '',
          }}
        />
      )}
      {specialNoteDesktop && (
        <Text
          variant="buttonLight"
          sx={{ display: ['none', 'block'] }}
          dangerouslySetInnerHTML={{
            __html: specialNoteDesktop?.childMarkdownRemark?.html || '',
          }}
        />
      )}
    </Flex>
  </Box>
);

export default SpecialNote;
